import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/yanre/Reveal";

// Pre-form conversion introduction (2026-09, GA4 funnel finding: visitors
// abandon at form START due to perceived complexity). Communicates within
// ~2s: ONLY 4 steps, 1 minute, direct YANRE FITNESS China factory supply,
// professional consultation, after-sales support. Copy/visuals ONLY — the
// form, its questions, business logic and tracking are untouched.
// Step labels reuse each form's existing localized step keys so the journey
// terminology always matches the actual funnel, in every locale.
export const FormIntro = ({ sub1, sub2, support, steps, minute, testidPrefix = "form" }) => (
  <div data-testid={`${testidPrefix}-intro`}>
    {/* Secondary headline — white + YANRE red, below the main H2, above body copy */}
    <Reveal delay={0.12}>
      <p
        className="mt-6 font-display text-2xl font-extrabold uppercase leading-[1.05] tracking-tight sm:text-3xl lg:text-4xl"
        data-testid={`${testidPrefix}-intro-headline`}
      >
        <span className="text-white">{sub1}</span>{" "}
        <span className="text-signal">{sub2}</span>
      </p>
    </Reveal>
    {/* Supporting message — deliberately more prominent than the old small copy */}
    <Reveal delay={0.18}>
      <p
        className="mt-5 max-w-2xl text-lg leading-relaxed text-titanium/90 sm:text-xl"
        data-testid={`${testidPrefix}-intro-support`}
      >
        {support}
      </p>
    </Reveal>
    {/* 4-step journey — horizontal on desktop, clean 2×2 on mobile, no scroll */}
    <Reveal delay={0.24}>
      <div className="mt-8 border-y border-carbon-700 py-5" data-testid={`${testidPrefix}-intro-journey`}>
        <ol className="grid grid-cols-2 gap-x-4 gap-y-3 sm:flex sm:items-center">
          {steps.map((label, i) => (
            <li key={i} className="flex items-center gap-2.5" data-testid={`${testidPrefix}-intro-step-${i + 1}`}>
              <span className="font-mono text-xs text-signal sm:text-sm">{String(i + 1).padStart(2, "0")}</span>
              <span className="font-display text-sm font-bold uppercase tracking-wide text-white sm:text-base">{label}</span>
              {i < steps.length - 1 && (
                <ArrowRight className="ml-3 hidden h-4 w-4 shrink-0 text-signal/70 sm:ml-5 sm:block rtl:-scale-x-100" />
              )}
            </li>
          ))}
        </ol>
        <p
          className="mt-4 font-mono text-[11px] uppercase tracking-[0.3em] text-signal sm:text-xs"
          data-testid={`${testidPrefix}-intro-minute`}
        >
          {minute}
        </p>
      </div>
    </Reveal>
  </div>
);
